import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: true,
  userRole: 'guest', // Default is guest
  userDetails: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action) {
      state.isAuthenticated = true;
      state.userRole = action.payload.role;
      state.userDetails = action.payload.userDetails;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.userRole = 'guest';
      state.userDetails = null;
    },
    setUserRole(state, action) {
      state.userRole = action.payload;
    },
  },
});

export const { login, logout, setUserRole } = authSlice.actions;
export default authSlice.reducer;
